import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const HOUSEHOLDPOPULATIONDENSITYACRESDIFF_LAYER_ID =
  'householdPopulationDensityAcresDiffLayer';

const layerConfig = {
  title: 'Household Population Density per acres Difference',
};

function HouseholdPopulationDensityAcresDiffLayer() {
  const dispatch = useDispatch();
  const { householdPopulationDensityAcresDiffLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, householdPopulationDensityAcresDiffLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (householdPopulationDensityAcresDiffLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HOUSEHOLDPOPULATIONDENSITYACRESDIFF_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: householdPopulationDensityAcresDiffLayer.visible,
      opacity: householdPopulationDensityAcresDiffLayer.opacity,
      getFillColor: colorBins({
        attr: 'household_population_density_acres_diff',
        domain: [-46, -10, -1, 0, 1, 10, 161],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HOUSEHOLDPOPULATIONDENSITYACRESDIFF_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['household_population_density_acres_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default HouseholdPopulationDensityAcresDiffLayer;
